import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { ChevronLeftIcon } from '@/icons';
import { useIsInLti } from '@/shared/lti';
import { Button } from '@/ui_v3';
type LtiNavigationPageKey = 'lti.nav.zepQuiz' | 'lti.nav.publicQuiz' | 'lti.nav.createQuiz';
interface LtiNavigationBarProps {
  currentPageKey: LtiNavigationPageKey;
}
export function LtiNavigationBar({
  currentPageKey
}: LtiNavigationBarProps) {
  const {
    t
  } = useTranslation(['common']);
  const router = useRouter();
  const isInLti = useIsInLti();
  if (!isInLti) return null;
  const isLanding = router.pathname === '/lti/deep-linking';
  const handleBack = () => {
    router.back();
  };
  return <div className="sticky top-0 z-50 flex items-center border-b border-alternative bg-white px-md py-sm" data-sentry-component="LtiNavigationBar" data-sentry-source-file="LtiNavigationBar.tsx">
      {!isLanding && <Button variant="transparent" intent="neutral" size="sm" onClick={handleBack} className="mr-sm">
          <div className="flex items-center gap-3xs">
            <ChevronLeftIcon size="xs" />
            <span>{t('lti.nav.back')}</span>
          </div>
        </Button>}
      <div className="flex items-center gap-2xs text-body-sm-medium text-alternative">
        <span>{t('lti.nav.zepQuiz')}</span>
        {!isLanding && <>
            <span className="text-tertiary">{'>'}</span>
            <span>{t(currentPageKey)}</span>
          </>}
      </div>
    </div>;
}